var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 152 152",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.836 1.21v1.816c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21V1.21A1.214 1.214 0 0 0 35.857 0h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM45.277 4.231h-2.793a1.439 1.439 0 0 1-1.438-1.438V1.439c0-.795.644-1.44 1.438-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15 4.231V0h2.793c.795 0 1.439.644 1.439 1.439V4.23H45.15ZM52.195 4.146v.085h1.29v-1.29h-.084c0 .668-.541 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36 4.231V1.44c0-.795.644-1.44 1.438-1.44h1.354c.795 0 1.439.645 1.439 1.44V4.23h-4.232ZM73.883 1.21v1.816c0 .668.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.21V1.21A1.214 1.214 0 0 0 76.905 0h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM86.324 4.231h-4.231V1.44c0-.795.644-1.44 1.438-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.195 4.231V0h2.793c.795 0 1.439.644 1.439 1.439V4.23h-4.232ZM94.404 1.21v1.816c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21V1.21A1.213 1.213 0 0 0 97.426 0h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM101.451 4.146v.085h1.291v-1.29h-.085c0 .668-.541 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.846 4.231h-4.232V1.44c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.719 4.231V0h2.793c.794 0 1.438.644 1.438 1.439V4.23h-4.231ZM36.941 5.315V7.13c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21V5.315a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM49.382 4.104H45.15v4.232h4.232V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 4.104h-4.231v4.232h4.231V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36 4.104h4.23v2.793c0 .795-.643 1.439-1.438 1.439H53.36V4.104ZM86.324 4.104v4.232h-2.793a1.439 1.439 0 0 1-1.438-1.439V4.104h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.427 4.104h-4.232v4.232h4.232V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3 8.335V4.103h2.794c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM102.742 8.335h-2.793a1.439 1.439 0 0 1-1.438-1.439V5.542c0-.794.644-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 4.104h-4.232v4.232h4.232V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 4.104h-4.231v4.232h4.231V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 4.104h-4.232v4.232h4.232V4.104Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 8.335V4.103h2.793c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM45.277 12.44h-2.793a1.439 1.439 0 0 1-1.438-1.438V9.648c0-.795.644-1.44 1.438-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15 8.209h4.232v2.793c0 .794-.644 1.438-1.439 1.438H45.15V8.21ZM57.463 12.44V9.648c0-.795.644-1.44 1.439-1.44h1.354c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM77.986 9.42v1.815c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21V9.418a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM90.428 8.209v2.793c0 .794-.644 1.438-1.439 1.438h-1.354a1.439 1.439 0 0 1-1.439-1.438V8.209h4.232ZM110.95 8.209h-4.231v4.232h4.231V8.209Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 8.209h-4.232v4.232h4.232V8.209Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 8.209h4.231v2.793c0 .794-.644 1.438-1.438 1.438h-2.793V8.21ZM61.695 12.313v2.793c0 .795-.644 1.439-1.438 1.439h-1.354a1.439 1.439 0 0 1-1.44-1.439v-2.793h4.232ZM69.906 16.545h-2.793a1.439 1.439 0 0 1-1.438-1.439v-1.354c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.777 16.545v-4.232h2.793c.795 0 1.439.644 1.439 1.44v2.792h-4.232ZM80.928 16.46v.085h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.092 16.545v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.44v2.792h-4.231ZM90.3 13.524v1.815c0 .669.542 1.206 1.211 1.206h1.815c.673 0 1.21-.542 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM97.346 16.46v.085h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.742 16.545h-4.231v-2.793c0-.795.644-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 12.313h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 12.313h-4.231v4.232h4.231v-4.232ZM37.068 20.65h-4.231v-2.793c0-.795.644-1.44 1.439-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 16.418H36.94v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 16.418h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 16.418H45.15v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 20.65v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM61.568 17.628v1.816c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.812a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM82.219 20.65h-2.793a1.439 1.439 0 0 1-1.439-1.44v-1.353c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.323 16.418h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.195 20.65v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.792h-4.232ZM98.637 20.65h-2.793a1.439 1.439 0 0 1-1.439-1.44v-1.353c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.741 16.418H98.51v4.232h4.231v-4.232ZM110.951 16.418v2.793c0 .794-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.438-1.44v-2.792h4.231ZM37.067 20.523h-4.231v4.231h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 20.523H36.94v4.231h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 20.523h-4.231v4.231h4.231v-4.232ZM74.01 24.754h-2.793a1.439 1.439 0 0 1-1.439-1.439v-1.354c0-.794.644-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.883 24.754v-4.232h2.793c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM102.741 20.523H98.51v4.231h4.231v-4.232ZM115.057 24.754h-2.793a1.439 1.439 0 0 1-1.439-1.439v-1.354c0-.794.644-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 24.754v-4.232h2.793c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM37.068 24.628v2.793c0 .794-.644 1.438-1.438 1.438h-1.354a1.439 1.439 0 0 1-1.44-1.438v-2.793h4.232ZM45.277 24.628v2.793c0 .794-.644 1.438-1.438 1.438h-1.355a1.439 1.439 0 0 1-1.438-1.438v-2.793h4.231ZM49.254 28.86v-2.793c0-.795.644-1.44 1.439-1.44h1.354c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM57.463 25.838v1.816c0 .668.541 1.205 1.21 1.205h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM64.51 28.774v.085h1.29v-1.29h-.084c0 .668-.542 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.674 28.86v-2.793c0-.795.644-1.44 1.438-1.44h1.355c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM78.115 24.628v2.793c0 .794-.644 1.438-1.438 1.438h-1.355a1.439 1.439 0 0 1-1.438-1.438v-2.793h4.231ZM82.092 28.86v-2.793c0-.795.644-1.44 1.439-1.44h1.354c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM90.3 25.838v1.816c0 .668.542 1.205 1.211 1.205h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM102.741 24.628H98.51v4.231h4.231v-4.231ZM106.719 25.838v1.816c0 .668.541 1.205 1.21 1.205h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM119.159 24.628h-4.231v4.231h4.231v-4.231ZM53.485 28.731h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36 32.963V28.73h2.792c.795 0 1.439.644 1.439 1.44v2.792h-4.232ZM65.8 32.963h-4.23V30.17c0-.795.643-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.905 28.731h-4.231v4.232h4.231v-4.232ZM80.928 32.879v.085h1.29v-1.291h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.323 28.731h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.195 32.963V28.73h2.793c.795 0 1.439.644 1.439 1.44v2.792h-4.232ZM102.741 28.731H98.51v4.232h4.231v-4.232ZM119.159 28.731h-4.231v4.232h4.231v-4.232ZM8.338 37.067H5.545a1.439 1.439 0 0 1-1.439-1.438v-1.354c0-.795.645-1.44 1.44-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 32.837H8.21v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.546 32.837h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.65 32.837h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.755 32.837h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.858 32.837h-4.231v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.732 37.067v-4.231h2.793c.795 0 1.439.644 1.439 1.439v2.792h-4.232ZM41.045 37.067v-2.792c0-.795.644-1.44 1.439-1.44h1.354c.794 0 1.438.645 1.438 1.44v2.792h-4.231ZM48.092 36.983v.085h1.29v-1.29h-.084c0 .668-.542 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 32.837h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.59 32.837h-4.23v4.231h4.23v-4.231ZM65.8 32.837h-4.232v4.231H65.8v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.905 32.837h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.777 37.067v-4.231h2.793c.795 0 1.439.644 1.439 1.439v2.792h-4.232ZM82.219 37.067h-2.793a1.439 1.439 0 0 1-1.439-1.438v-1.354c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.092 32.837h4.231v2.793c0 .794-.644 1.438-1.438 1.438h-2.793v-4.231ZM90.3 34.047v1.815c0 .669.542 1.206 1.211 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM102.742 32.837v4.231h-2.793a1.439 1.439 0 0 1-1.438-1.438v-2.793h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 32.837h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.719 37.067v-4.231h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM119.159 32.837h-4.231v4.231h4.231v-4.231ZM131.475 37.067h-4.232v-2.792c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.346 37.067v-4.231h2.792c.795 0 1.439.644 1.439 1.439v2.792h-4.231ZM147.764 34.047v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM32.964 36.941h-4.232v4.232h4.232V36.94ZM45.276 36.941h-4.231v4.232h4.231V36.94Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 36.941H45.15v4.232h4.232V36.94Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 36.941h-4.231v4.232h4.231V36.94Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36 36.941h4.23v2.793c0 .795-.643 1.439-1.438 1.439H53.36V36.94ZM65.8 36.941v4.232h-2.792a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.905 36.941h-4.231v4.232h4.231V36.94Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.777 36.941h4.232v2.793c0 .795-.644 1.439-1.439 1.439h-2.793V36.94ZM94.404 38.152v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM106.845 36.941h-4.232v4.232h4.232V36.94Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 36.941h-4.231v4.232h4.231V36.94ZM113.764 41.088v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 36.941h-4.231v4.232h4.231V36.94ZM131.475 36.941v2.793a1.44 1.44 0 0 1-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM139.555 41.173V38.38c0-.794.644-1.439 1.438-1.439h1.354c.795 0 1.439.645 1.439 1.44v2.792h-4.231ZM8.338 45.277H4.106v-2.793c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 41.046H8.21v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.315 45.277v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM28.86 45.277h-2.793a1.439 1.439 0 0 1-1.44-1.438v-1.355c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.964 41.046h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.836 45.277v-4.231h2.793c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM45.276 41.046h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 41.046H45.15v4.231h4.232v-4.231ZM72.719 45.192v.085h1.29v-1.29h-.084c0 .668-.542 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.115 45.277h-4.231v-2.793c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.218 41.046h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.092 45.277v-4.231h2.793c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM89.137 45.192v.085h1.29v-1.29h-.084c0 .668-.542 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3 45.277v-2.793c0-.794.645-1.438 1.44-1.438h1.354c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM106.846 41.046v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 41.046h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 41.046h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 41.046h4.231v2.793c0 .794-.644 1.438-1.438 1.438h-2.793v-4.231ZM123.137 45.277v-2.793c0-.794.644-1.438 1.438-1.438h1.355c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM143.787 41.046v4.231h-2.793a1.438 1.438 0 0 1-1.438-1.438v-2.793h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 41.046h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 45.277v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM8.337 45.15H4.105v4.232h4.232V45.15ZM16.546 45.15h-4.231v4.232h4.231V45.15ZM32.965 45.15v4.232h-2.793a1.439 1.439 0 0 1-1.439-1.439V45.15h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.836 45.15h4.231v2.793c0 .795-.644 1.439-1.438 1.439h-2.793V45.15ZM45.277 45.15v4.232h-2.793a1.439 1.439 0 0 1-1.438-1.439V45.15h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 45.15H45.15v4.232h4.232V45.15Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 49.382V45.15h2.793c.794 0 1.438.645 1.438 1.439v2.793h-4.231ZM68.613 49.297v.084h1.29v-1.29h-.084c0 .668-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.01 49.382h-4.232v-2.793c0-.794.644-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.883 45.15h4.231v2.793c0 .795-.644 1.439-1.438 1.439h-2.793V45.15ZM90.428 49.382h-2.793a1.439 1.439 0 0 1-1.439-1.439V46.59c0-.794.644-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.532 45.15h-4.231v4.232h4.231V45.15Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.404 49.382V45.15h2.793c.795 0 1.439.645 1.439 1.439v2.793h-4.232ZM110.95 45.15h-4.231v4.232h4.231V45.15Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 45.15h-4.232v4.232h4.232V45.15ZM121.973 49.297v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 45.15h-4.231v4.232h4.231V45.15Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 45.15h-4.232v4.232h4.232V45.15Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.346 49.382V45.15h2.792c.795 0 1.439.645 1.439 1.439v2.793h-4.231ZM147.893 45.15v2.793a1.44 1.44 0 0 1-1.439 1.439H145.1a1.439 1.439 0 0 1-1.439-1.439V45.15h4.232ZM8.337 49.255H4.105v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 49.255H8.21v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.546 49.255h-4.231v4.231h4.231v-4.231ZM24.756 53.486h-4.232v-2.792c0-.795.645-1.44 1.44-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.627 53.486v-4.231h2.793c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM57.592 53.486h-2.793a1.439 1.439 0 0 1-1.439-1.438v-1.355c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.463 53.486v-4.231h2.793c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM69.906 53.486h-4.231v-2.792c0-.795.644-1.44 1.439-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.777 49.255h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM77.986 50.465v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.81a1.214 1.214 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM94.533 49.255v2.793c0 .794-.644 1.438-1.439 1.438H91.74a1.439 1.439 0 0 1-1.438-1.438v-2.793h4.231ZM106.846 53.486h-2.793a1.439 1.439 0 0 1-1.439-1.438v-1.355c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 49.255h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.822 49.255h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM123.266 53.486h-4.232v-2.792c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.137 49.255h4.231v2.793c0 .794-.644 1.438-1.438 1.438h-2.793v-4.231ZM135.578 49.255v4.231h-2.793a1.438 1.438 0 0 1-1.438-1.438v-2.793h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683 49.255h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.555 53.486v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM147.764 50.465v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM8.337 53.36H4.105v4.23h4.232v-4.23Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 53.36H8.21v4.23h4.232v-4.23Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.315 53.36h4.231v2.792c0 .795-.644 1.439-1.439 1.439h-2.792v-4.232ZM24.755 53.36h-4.232v4.23h4.232v-4.23ZM28.732 54.57v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21V54.57a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM48.092 57.506v.084h1.29V56.3h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 57.59v-2.792c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM61.695 53.36v2.792c0 .795-.644 1.439-1.438 1.439h-1.354a1.439 1.439 0 0 1-1.44-1.439V53.36h4.232ZM69.906 53.36v2.792c0 .795-.644 1.439-1.439 1.439h-1.353a1.439 1.439 0 0 1-1.44-1.439V53.36h4.232ZM73.883 54.57v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.21V54.57a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM82.092 54.57v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.21V54.57a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM94.404 54.57v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21V54.57a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM110.951 53.36v2.792c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.438-1.439V53.36h4.231ZM123.266 53.36v2.792a1.44 1.44 0 0 1-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439V53.36h4.232ZM139.683 53.36h-4.232v4.23h4.232v-4.23Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.555 53.36h4.231v2.792c0 .795-.644 1.439-1.439 1.439h-2.792v-4.232ZM8.338 57.464v2.793c0 .794-.644 1.438-1.439 1.438H5.545a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232ZM24.755 57.464h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.627 61.695v-4.231h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM37.068 61.695h-2.792a1.439 1.439 0 0 1-1.44-1.438v-1.354c0-.795.645-1.44 1.44-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 57.464H36.94v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 57.464h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 57.464H45.15v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 57.464h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36 61.695v-4.231h2.792c.795 0 1.439.644 1.439 1.439v2.792h-4.232ZM115.057 61.695h-4.232v-2.792c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 61.695v-4.231h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM139.684 57.464v2.793a1.44 1.44 0 0 1-1.439 1.438h-1.354a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232ZM147.893 61.695h-4.232v-2.792c0-.795.644-1.44 1.439-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 61.695v-4.231h2.792c.795 0 1.439.644 1.439 1.439v2.792h-4.231ZM0 62.779v1.815c0 .669.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.81A1.21 1.21 0 0 0 0 62.778ZM8.209 62.779v1.815c0 .669.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.215-1.21H9.42a1.21 1.21 0 0 0-1.211 1.21ZM24.755 61.568h-4.232V65.8h4.232v-4.232ZM45.276 61.568h-4.231V65.8h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 61.568H45.15V65.8h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 61.568h-4.231V65.8h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.59 61.568h-4.23V65.8h4.23v-4.232ZM98.51 62.779v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.211-.542 1.211-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21H99.72a1.21 1.21 0 0 0-1.21 1.21ZM115.054 61.568h-4.232V65.8h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 61.568h-4.231V65.8h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.033 65.8v-4.232h2.793c.795 0 1.439.644 1.439 1.439V65.8h-4.232ZM127.242 62.779v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM142.496 65.716v.084h1.291v-1.29h-.085c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 61.568h-4.232V65.8h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 61.568h4.231v2.793c0 .795-.644 1.439-1.439 1.439h-2.792v-4.232ZM24.756 65.673v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.858 65.673h-4.231v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.732 69.904v-4.231h2.793c.795 0 1.439.644 1.439 1.439v2.792h-4.232ZM45.276 65.673h-4.231v4.231h4.231v-4.231ZM57.592 65.673v2.793c0 .794-.644 1.438-1.439 1.438H54.8a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232ZM102.613 66.883v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.812a1.21 1.21 0 0 0-1.21 1.21ZM115.055 65.673v2.793c0 .794-.644 1.438-1.439 1.438h-1.354a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232ZM123.266 65.673v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.137 69.904v-4.231h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM131.346 66.883v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.81a1.213 1.213 0 0 0-1.214-1.211h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM143.787 69.904h-2.793a1.438 1.438 0 0 1-1.438-1.438v-1.354c0-.795.644-1.44 1.438-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66 65.673h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM8.209 74.009v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793H8.21ZM32.964 69.777h-4.232v4.232h4.232v-4.232ZM45.277 69.777v2.793c0 .795-.644 1.439-1.438 1.439h-1.355a1.439 1.439 0 0 1-1.438-1.439v-2.793h4.231ZM48.092 73.925v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 74.009v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM94.404 70.988v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM105.555 73.925v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.719 74.009v-2.793c0-.795.644-1.439 1.438-1.439h1.355c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM127.242 74.009v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM134.287 73.925v.084h1.291v-1.29h-.085c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.451 74.009v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM12.441 73.882v2.793c0 .794-.644 1.438-1.438 1.438H9.649a1.439 1.439 0 0 1-1.44-1.438v-2.793h4.232ZM28.86 78.113h-2.793a1.439 1.439 0 0 1-1.44-1.438V75.32c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.732 73.882h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM36.941 75.092v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM49.383 78.113H45.15V75.32c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 73.882h4.231v2.793c0 .794-.644 1.438-1.438 1.438h-2.793v-4.231ZM102.742 78.113h-4.231V75.32c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 73.882h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 73.882h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.822 78.113v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM119.033 75.092v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM131.475 73.882v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 73.882h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683 73.882h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.786 73.882h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 73.882h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 78.113v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM4.105 79.197v1.815c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.214-1.21H5.316a1.21 1.21 0 0 0-1.21 1.21ZM20.523 79.197v1.815c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM49.383 77.986v2.793c0 .795-.644 1.439-1.439 1.439H46.59a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM53.36 82.218v-2.793c0-.795.644-1.439 1.438-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM102.742 77.986v2.793c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.438-1.439v-2.793h4.231ZM115.054 77.986h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 82.218v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM147.893 77.986v2.793a1.44 1.44 0 0 1-1.439 1.439H145.1a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM8.209 86.323V83.53c0-.794.644-1.438 1.439-1.438h1.354c.794 0 1.438.644 1.438 1.438v2.793H8.21ZM24.627 83.302v1.815c0 .669.542 1.206 1.21 1.206h1.816c.672 0 1.21-.541 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM36.941 83.302v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM57.592 82.092v2.793c0 .794-.644 1.438-1.439 1.438H54.8a1.439 1.439 0 0 1-1.439-1.438v-2.793h4.232ZM94.404 86.323V83.53c0-.794.644-1.438 1.439-1.438h1.354c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM106.846 86.323h-2.793a1.439 1.439 0 0 1-1.439-1.438V83.53c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 82.092h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.822 82.092h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM123.266 86.323h-4.232V83.53c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 82.092h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 82.092h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 82.092h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683 82.092h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.555 86.323v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM0 87.406v1.815c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.81A1.21 1.21 0 0 0 0 87.405ZM7.045 90.343v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 86.195H8.21v4.232h4.232v-4.232ZM16.418 87.406v1.815c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM32.965 90.427h-2.793a1.439 1.439 0 0 1-1.439-1.439v-1.354c0-.795.645-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.836 90.427v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM43.986 90.343v.084h1.29v-1.29h-.084c0 .668-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.383 90.427H45.15v-2.793c0-.795.644-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 90.427v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM98.637 86.195v4.232h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.51 90.427v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793H98.51ZM123.265 86.195h-4.232v4.232h4.232v-4.232ZM131.475 86.195v2.793a1.44 1.44 0 0 1-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM139.684 86.195v4.232h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.786 86.195h-4.231v4.232h4.231v-4.232ZM2.941 94.447v.085h1.291v-1.29h-.085c0 .668-.541 1.205-1.206 1.205Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.338 94.531H4.106v-2.793c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44 90.3H8.21v4.232h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.315 94.531V90.3h2.792c.795 0 1.439.644 1.439 1.439v2.792h-4.231ZM24.756 94.531h-2.793a1.439 1.439 0 0 1-1.439-1.439V91.74c0-.795.645-1.44 1.44-1.44h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.627 94.531V90.3h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM37.067 90.3h-4.231v4.232h4.231v-4.231ZM45.277 94.531h-2.793a1.439 1.439 0 0 1-1.438-1.439V91.74c0-.795.644-1.44 1.438-1.44h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 90.3H45.15v4.232h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 90.3h4.231v2.794c0 .794-.644 1.438-1.438 1.438h-2.793v-4.231ZM102.742 90.3v2.794c0 .794-.644 1.438-1.439 1.438h-1.354a1.439 1.439 0 0 1-1.438-1.438V90.3h4.231ZM110.822 91.511v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.812a1.21 1.21 0 0 0-1.21 1.21ZM123.265 90.3h-4.232v4.232h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.137 94.531V90.3h2.793c.794 0 1.438.644 1.438 1.439v2.792h-4.231ZM143.787 90.3v4.232h-2.793a1.438 1.438 0 0 1-1.438-1.438V90.3h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 90.3h-4.232v4.232h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 94.531V90.3h2.792c.795 0 1.439.644 1.439 1.439v2.792h-4.231ZM4.232 98.637H.001v-2.793c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.105 94.405h4.232v2.793c0 .795-.644 1.439-1.439 1.439H4.105v-4.232ZM16.418 95.615v1.816c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.812a1.214 1.214 0 0 0-1.215-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM27.568 98.552v.084h1.291v-1.29h-.085c0 .668-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.965 98.637h-4.232v-2.793c0-.795.645-1.439 1.439-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.067 94.405h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.941 98.637v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793H36.94ZM49.382 94.405H45.15v4.232h4.232v-4.232ZM53.36 98.637v-2.793c0-.795.644-1.439 1.438-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM72.719 98.552v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.883 98.637v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM86.324 98.637h-4.231v-2.793c0-.795.644-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.195 98.637v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM123.266 94.405v4.232h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 94.405h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.242 98.637v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM147.892 94.405h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 94.405h4.231v2.793c0 .795-.644 1.439-1.439 1.439h-2.792v-4.232ZM4.232 98.509H0v4.231h4.232v-4.231ZM12.441 102.74H9.65a1.438 1.438 0 0 1-1.44-1.438v-1.355c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.315 102.74v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM28.86 102.74h-2.793a1.438 1.438 0 0 1-1.44-1.438v-1.355c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.964 98.509h-4.232v4.231h4.232v-4.231ZM49.383 98.509v2.793c0 .794-.644 1.438-1.439 1.438H46.59a1.438 1.438 0 0 1-1.439-1.438v-2.793h4.232ZM57.592 98.509v2.793c0 .794-.644 1.438-1.439 1.438H54.8a1.438 1.438 0 0 1-1.439-1.438v-2.793h4.232ZM61.568 99.719v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM74.01 102.74h-2.793a1.438 1.438 0 0 1-1.439-1.438v-1.355c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.114 98.509h-4.231v4.231h4.231v-4.231ZM86.324 98.509v2.793c0 .794-.644 1.438-1.439 1.438h-1.354a1.438 1.438 0 0 1-1.438-1.438v-2.793h4.231ZM94.533 102.74H91.74a1.438 1.438 0 0 1-1.438-1.438v-1.355c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.404 102.74v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM102.613 99.719v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.812a1.21 1.21 0 0 0-1.21 1.21ZM127.369 98.509v2.793c0 .794-.644 1.438-1.439 1.438h-1.354a1.438 1.438 0 0 1-1.438-1.438v-2.793h4.231ZM135.578 102.74h-2.793a1.438 1.438 0 0 1-1.438-1.438v-1.355c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683 98.509h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.786 98.509h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 98.509h-4.232v4.231h4.232v-4.231ZM4.232 102.614H0v4.232h4.232v-4.232ZM16.418 106.845v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.439.644 1.439 1.439v2.793h-4.232ZM32.965 102.614v4.232h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.067 102.614h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.941 106.845v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793H36.94ZM57.463 106.845v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM78.114 102.614h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.986 106.845v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM98.637 102.614v2.793c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM113.764 106.761v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 106.845v-2.793c0-.795.644-1.439 1.438-1.439h1.355c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM126.078 106.761v.084h1.291v-1.29h-.085c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.242 106.845v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM139.683 102.614h-4.232v4.232h4.232v-4.232ZM147.892 102.614h-4.232v4.232h4.232v-4.232ZM4.232 106.719H0v4.231h4.232v-4.231ZM20.65 106.719v2.793c0 .794-.644 1.438-1.438 1.438h-1.354a1.438 1.438 0 0 1-1.44-1.438v-2.793h4.232ZM24.627 107.929v1.815c0 .669.542 1.206 1.21 1.206h1.816c.672 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.215-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM37.067 106.719h-4.231v4.231h4.231v-4.231ZM39.883 110.865v.085h1.29v-1.291h-.084c0 .669-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.045 110.95v-2.793c0-.794.644-1.438 1.439-1.438h1.354c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM61.695 106.719v2.793c0 .794-.644 1.438-1.438 1.438h-1.354a1.438 1.438 0 0 1-1.44-1.438v-2.793h4.232ZM65.674 110.95v-2.793c0-.794.644-1.438 1.438-1.438h1.355c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM78.114 106.719h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.218 106.719h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.323 106.719h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.195 110.95v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM102.742 110.95h-2.793a1.439 1.439 0 0 1-1.438-1.439v-1.354c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.613 110.95v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM109.66 110.865v.085h1.291v-1.291h-.085c0 .669-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.055 110.95h-4.232v-2.793c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 106.719h-4.231v4.231h4.231v-4.231ZM127.369 110.95h-2.793a1.438 1.438 0 0 1-1.438-1.439v-1.354c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.242 106.719h4.232v2.793c0 .794-.644 1.438-1.439 1.438h-2.793v-4.231ZM139.684 106.719v4.231h-2.793a1.438 1.438 0 0 1-1.439-1.438v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.786 106.719h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 106.719h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 110.95v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM4.232 110.823H0v4.232h4.232v-4.232ZM12.441 115.055H8.21v-2.793c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.315 115.055v-4.232h2.792c.795 0 1.439.644 1.439 1.439v2.793h-4.231ZM19.36 114.97v.084h1.29v-1.29h-.085c0 .668-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.523 115.055v-2.793c0-.795.645-1.439 1.44-1.439h1.353c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM37.068 110.823v4.232h-2.792a1.439 1.439 0 0 1-1.44-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 110.823H36.94v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 110.823h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15 115.055v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793H45.15ZM69.906 110.823v2.793c0 .795-.644 1.439-1.439 1.439h-1.353a1.439 1.439 0 0 1-1.44-1.439v-2.793h4.232ZM78.115 110.823v2.793c0 .795-.644 1.439-1.438 1.439h-1.355a1.439 1.439 0 0 1-1.438-1.439v-2.793h4.231ZM90.428 110.823v2.793c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM94.404 115.055v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM105.555 114.97v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.951 115.055h-4.231v-2.793c0-.795.644-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 110.823h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 110.823h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.033 115.055v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM130.182 114.97v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.346 115.055v-2.793c0-.795.644-1.439 1.438-1.439h1.354c.795 0 1.439.644 1.439 1.439v2.793h-4.231ZM147.893 110.823v4.232H145.1a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.995 110.823h-4.231v4.232h4.231v-4.232ZM4.232 114.928v2.793c0 .794-.644 1.438-1.438 1.438H1.44A1.438 1.438 0 0 1 0 117.721v-2.793h4.232ZM12.441 114.928v2.793c0 .794-.644 1.438-1.438 1.438H9.649a1.438 1.438 0 0 1-1.44-1.438v-2.793h4.232ZM20.65 119.159h-2.792a1.439 1.439 0 0 1-1.44-1.439v-1.354c0-.794.645-1.438 1.44-1.438h2.792v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.755 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.858 114.928h-4.231v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.732 119.159v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM49.254 116.138v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM57.463 116.138v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.81a1.21 1.21 0 0 0-1.211 1.21ZM69.777 116.138v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM77.986 116.138v1.815c0 .669.542 1.206 1.21 1.206h1.816c.673 0 1.21-.541 1.21-1.21v-1.811a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM98.636 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.741 114.928H98.51v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 114.928h-4.231v4.231h4.231v-4.231ZM119.159 114.928h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.265 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 114.928h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 114.928h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.683 114.928h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.555 119.159v-4.231h2.792c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM151.996 114.928v2.793c0 .794-.644 1.438-1.439 1.438h-1.354a1.438 1.438 0 0 1-1.438-1.438v-2.793h4.231ZM37.068 123.264h-4.231v-2.793c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 119.033H36.94v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 119.033h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15 123.264v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793H45.15ZM72.719 123.18v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.883 123.264v-2.793c0-.795.644-1.439 1.439-1.439h1.354c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM82.092 120.243v1.816c0 .668.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.211v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM98.637 119.033v2.793c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM110.951 119.033v2.793c0 .795-.644 1.439-1.439 1.439h-1.354a1.438 1.438 0 0 1-1.438-1.439v-2.793h4.231ZM119.159 119.033h-4.231v4.232h4.231v-4.232ZM135.577 119.033h-4.231v4.232h4.231v-4.232ZM37.067 123.137h-4.231v4.231h4.231v-4.231ZM49.254 127.368v-2.793c0-.794.644-1.438 1.439-1.438h1.354c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM60.404 127.284v.085h1.29v-1.291h-.084c0 .669-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.568 127.368v-2.793c0-.794.645-1.438 1.44-1.438h1.353c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM74.01 127.368h-2.793a1.439 1.439 0 0 1-1.439-1.439v-1.354c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.114 123.137h-4.231v4.231h4.231v-4.231ZM90.428 127.368h-4.232v-2.793c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3 127.368v-4.231h2.794c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM98.51 124.347v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.211-.541 1.211-1.21v-1.811a1.214 1.214 0 0 0-1.215-1.21H99.72a1.21 1.21 0 0 0-1.21 1.21ZM119.159 123.137h-4.231v4.231h4.231v-4.231ZM123.137 124.347v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.212 1.212 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM135.577 123.137h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.451 127.368v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM147.764 124.347v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.212 1.212 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM37.067 127.241h-4.231v4.232h4.231v-4.232ZM48.092 131.388v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 127.241h-4.231v4.232h4.231v-4.232ZM61.695 131.473h-2.792a1.439 1.439 0 0 1-1.44-1.439v-1.354c0-.795.645-1.439 1.44-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8 127.241h-4.232v4.232H65.8v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.674 131.473v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM78.115 127.241v2.793c0 .795-.644 1.439-1.438 1.439h-1.355a1.439 1.439 0 0 1-1.438-1.439v-2.793h4.231ZM90.427 127.241h-4.232v4.232h4.232v-4.232ZM106.719 128.451v1.816c0 .668.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.21v-1.812a1.213 1.213 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM113.764 131.388v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 127.241h-4.231v4.232h4.231v-4.232ZM130.182 131.388v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 127.241h-4.231v4.232h4.231v-4.232ZM143.66 128.451v1.816c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.21v-1.812a1.214 1.214 0 0 0-1.215-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM37.067 131.346h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 131.346H36.94v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.276 131.346h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.382 131.346H45.15v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.254 131.346h4.231v2.792c0 .795-.644 1.439-1.438 1.439h-2.793v-4.231ZM65.8 131.346h-4.232v4.231H65.8v-4.231ZM90.428 131.346v2.792c0 .795-.644 1.439-1.439 1.439h-1.354a1.439 1.439 0 0 1-1.439-1.439v-2.792h4.232ZM102.742 135.577h-2.793a1.439 1.439 0 0 1-1.438-1.439v-1.354c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.613 135.577v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM115.057 135.577h-4.232v-2.793c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.159 131.346h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.265 131.346h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 131.346h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 131.346h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 131.346h-4.231v4.231h4.231v-4.231ZM139.555 132.556v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.212 1.212 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM147.764 132.556v1.815c0 .669.541 1.206 1.21 1.206h1.815c.673 0 1.21-.541 1.21-1.21v-1.811a1.212 1.212 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM37.067 135.45h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.941 135.45h4.232v2.793c0 .795-.644 1.439-1.439 1.439h-2.793v-4.232ZM49.383 135.45v2.793c0 .795-.644 1.439-1.439 1.439H46.59a1.439 1.439 0 0 1-1.439-1.439v-2.793h4.232ZM56.3 139.598v.084h1.291v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.695 139.682h-4.231v-2.793c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8 135.45h-4.232v4.232H65.8v-4.232ZM82.092 136.66v1.816c0 .668.541 1.206 1.21 1.206h1.815c.673 0 1.21-.542 1.21-1.211v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM94.404 136.66v1.816c0 .668.542 1.206 1.21 1.206h1.816c.673 0 1.21-.542 1.21-1.211v-1.811a1.214 1.214 0 0 0-1.214-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM106.845 135.45h-4.232v4.232h4.232v-4.232ZM109.66 139.598v.084h1.291v-1.29h-.085c0 .668-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 135.45h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.928 135.45h4.231v2.793c0 .795-.644 1.439-1.438 1.439h-2.793v-4.232ZM127.369 135.45v4.232h-2.793a1.438 1.438 0 0 1-1.438-1.439v-2.793h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 135.45h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 135.45h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.451 139.682v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM143.66 136.66v1.816c0 .668.542 1.206 1.21 1.206h1.816c.672 0 1.21-.542 1.21-1.211v-1.811a1.214 1.214 0 0 0-1.215-1.21h-1.811a1.21 1.21 0 0 0-1.21 1.21ZM37.067 139.556h-4.231v4.231h4.231v-4.231ZM52.195 143.702v.085h1.29v-1.291h-.084c0 .669-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.592 143.787H53.36v-2.793c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.694 139.556h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.568 139.556H65.8v2.792c0 .795-.644 1.439-1.439 1.439h-2.793v-4.231ZM68.613 143.702v.085h1.29v-1.291h-.084c0 .669-.541 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.01 143.787h-4.232v-2.793c0-.794.644-1.438 1.439-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.114 139.556h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.986 143.787v-4.231h2.793c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM89.137 143.702v.085h1.29v-1.291h-.084c0 .669-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3 143.787v-2.793c0-.794.645-1.438 1.44-1.438h1.354c.794 0 1.438.644 1.438 1.438v2.793h-4.231ZM102.742 143.787h-2.793a1.439 1.439 0 0 1-1.438-1.439v-1.354c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 139.556h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.95 139.556h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.822 139.556h4.232v2.792c0 .795-.644 1.439-1.439 1.439h-2.793v-4.231ZM117.869 143.702v.085h1.291v-1.291h-.085c0 .669-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.033 143.787v-2.793c0-.794.644-1.438 1.439-1.438h1.354c.795 0 1.439.644 1.439 1.438v2.793h-4.232ZM126.078 143.702v.085h1.291v-1.291h-.085c0 .669-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 139.556h-4.232v4.231h4.232v-4.231ZM147.764 143.787v-2.793c0-.794.644-1.438 1.438-1.438h1.354c.795 0 1.439.644 1.439 1.438v2.793h-4.231ZM37.068 143.659v4.232h-2.792a1.439 1.439 0 0 1-1.44-1.439v-2.793h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 143.659H36.94v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.045 147.891v-4.232h2.793c.794 0 1.438.644 1.438 1.439v2.793h-4.231ZM53.486 147.891h-2.792a1.44 1.44 0 0 1-1.44-1.439v-1.354c0-.795.645-1.439 1.44-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.59 143.659h-4.23v4.232h4.23v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.694 143.659h-4.231v4.232h4.231v-4.232ZM69.906 147.891h-2.793a1.44 1.44 0 0 1-1.438-1.439v-1.354c0-.795.644-1.439 1.439-1.439h2.792v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.009 143.659h-4.232v4.232h4.232v-4.232ZM82.218 143.659h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.323 143.659h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.427 143.659h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.532 143.659h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.404 147.891v-4.232h2.793c.795 0 1.439.644 1.439 1.439v2.793h-4.232ZM110.95 143.659h-4.231v4.232h4.231v-4.232ZM119.16 147.891h-2.793a1.44 1.44 0 0 1-1.438-1.439v-1.354c0-.795.644-1.439 1.438-1.439h2.793v4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.265 143.659h-4.232v4.232h4.232v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 143.659h-4.231v4.232h4.231v-4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.474 143.659h-4.232v4.232h4.232v-4.232ZM146.602 147.807v.084h1.29v-1.29h-.084c0 .668-.542 1.206-1.206 1.206Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.995 143.659h-4.231v4.232h4.231v-4.232ZM41.174 147.765v4.231H38.38a1.439 1.439 0 0 1-1.439-1.439v-2.792h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.045 147.765h4.231v2.792c0 .795-.644 1.439-1.438 1.439h-2.793v-4.231ZM61.695 147.765v2.792c0 .795-.644 1.439-1.438 1.439h-1.354a1.439 1.439 0 0 1-1.44-1.439v-2.792h4.232ZM74.01 147.765v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.792h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.114 147.765h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.986 147.765h4.232v2.792c0 .795-.644 1.439-1.439 1.439h-2.793v-4.231ZM94.533 147.765v4.231H91.74a1.439 1.439 0 0 1-1.438-1.439v-2.792h4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.636 147.765h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.741 147.765H98.51v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.845 147.765h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.719 147.765h4.231v2.792c0 .795-.644 1.439-1.438 1.439h-2.793v-4.231ZM123.266 147.765v4.231h-2.793a1.439 1.439 0 0 1-1.439-1.439v-2.792h4.232Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.368 147.765h-4.231v4.231h4.231v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.242 147.765h4.232v2.792c0 .795-.644 1.439-1.439 1.439h-2.793v-4.231ZM143.787 151.996h-2.793a1.438 1.438 0 0 1-1.438-1.439v-1.354c0-.794.644-1.438 1.438-1.438h2.793v4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.892 147.765h-4.232v4.231h4.232v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 147.765h4.231v2.792c0 .795-.644 1.439-1.439 1.439h-2.792v-4.231Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.39 19.352v-9.084c0-4.032-.55-5.016-.785-5.252-.237-.236-1.22-.785-5.253-.785h-9.083c-4.033 0-5.017.549-5.253.785-.236.236-.785 1.22-.785 5.252v9.084c0 4.032.55 5.016.785 5.253.236.235 1.22.784 5.253.784h9.083c4.032 0 5.016-.549 5.253-.784.236-.237.784-1.22.784-5.253ZM19.351 0C27.646 0 29.62 1.974 29.62 10.268v9.084c0 8.294-1.975 10.269-10.27 10.269H10.27C1.974 29.62 0 27.646 0 19.35v-9.083C0 1.974 1.974 0 10.269 0h9.083Zm-2.595 8.463c3.554 0 4.4.847 4.4 4.4v3.894c0 3.554-.846 4.4-4.4 4.4h-3.893c-3.554 0-4.401-.846-4.401-4.4v-3.894c0-3.553.847-4.4 4.4-4.4h3.894ZM147.256 19.352v-9.084c0-4.032-.548-5.016-.784-5.252-.237-.236-1.22-.785-5.253-.785h-9.083c-4.033 0-5.017.549-5.252.785-.236.236-.785 1.22-.785 5.252v9.084c0 4.032.549 5.016.785 5.253.235.235 1.219.784 5.252.784h9.083c4.033 0 5.016-.549 5.253-.784.236-.237.784-1.22.784-5.253ZM141.219 0c8.294 0 10.269 1.974 10.269 10.268v9.084c0 8.294-1.975 10.269-10.269 10.269h-9.083c-8.294 0-10.269-1.975-10.269-10.27v-9.083C121.867 1.974 123.842 0 132.136 0h9.083Zm-2.595 8.463c3.555 0 4.401.847 4.401 4.4v3.894c0 3.554-.846 4.4-4.401 4.4h-3.893c-3.554 0-4.401-.846-4.401-4.4v-3.894c0-3.553.847-4.4 4.401-4.4h3.893ZM25.39 141.219v-9.084c0-4.032-.55-5.016-.785-5.252-.237-.236-1.22-.784-5.253-.784h-9.083c-4.033 0-5.017.548-5.253.784-.236.236-.785 1.22-.785 5.252v9.084c0 4.033.55 5.016.785 5.253.236.235 1.22.784 5.253.784h9.083c4.032 0 5.016-.549 5.253-.784.236-.237.784-1.22.784-5.253Zm-6.038-19.352c8.294 0 10.269 1.975 10.269 10.268v9.084c0 8.294-1.975 10.269-10.27 10.269H10.27C1.974 151.488 0 149.513 0 141.219v-9.084c0-8.293 1.974-10.268 10.269-10.268h9.083Zm-2.595 8.463c3.554 0 4.4.847 4.4 4.401v3.893c0 3.554-.846 4.401-4.4 4.401h-3.893c-3.554 0-4.401-.847-4.401-4.401v-3.893c0-3.554.847-4.401 4.4-4.401h3.894Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 75.023c0-5.259 0-7.888 1.023-9.896a9.388 9.388 0 0 1 4.104-4.104C67.135 60 69.764 60 75.023 60h1.954c5.259 0 7.888 0 9.896 1.023a9.388 9.388 0 0 1 4.104 4.104C92 67.135 92 69.764 92 75.023v1.954c0 5.259 0 7.888-1.023 9.896a9.388 9.388 0 0 1-4.104 4.104C84.865 92 82.236 92 76.977 92h-1.954c-5.259 0-7.888 0-9.896-1.023a9.388 9.388 0 0 1-4.104-4.104C60 84.865 60 82.236 60 76.977v-1.954Z",
    fill: "#868695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.23 71.872a4.7 4.7 0 0 0-2.652.814V68h-2.119v8.643c0 2.63 2.14 4.744 4.76 4.744A4.767 4.767 0 0 0 88 76.617c0-2.669-2.118-4.745-4.77-4.745Zm-9.605 5.378-1.938-5.045h-1.485l-1.95 5.045-1.949-5.045H64l3.407 8.87h1.485l2.044-5.283 2.055 5.283h1.485l3.397-8.87h-2.298l-1.95 5.045Zm9.594 2.018a2.632 2.632 0 0 1-2.641-2.641c0-1.495 1.135-2.631 2.652-2.631 1.516 0 2.652 1.183 2.652 2.63 0 1.448-1.21 2.642-2.668 2.642h.005Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h152v152H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(60 60)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.228174e5470974b528254ce522e0e29f.svg";
export { ForwardRef as ReactComponent };